<template>
  <b-button
    v-if="visible"
    variant="link"
    class="quote-log-launcher"
    :aria-label="ariaLabel"
    @click="open"
  >
    <span
      class="quote-log-launcher__icon"
      aria-hidden="true"
    >
      <feather-icon
        icon="MessageSquareIcon"
        size="16"
      />
    </span>
    <span class="quote-log-launcher__text">Bitácora</span>
    <span
      v-if="count"
      class="quote-log-launcher__count"
      aria-hidden="true"
    >{{ count }}</span>
  </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'

const QUOTE_PARAM_BY_ROUTE = {
  clientQuote: 'id',
  clientQuoteMetadata: 'id',
  quoteInvoices: 'quoteId',
  prequote: 'quoteId',
  addProductsToQuote: 'quoteId',
  editQuote: 'quoteId',
  checkout: 'quoteId',
  firstRound: 'quoteId',
  auctionInProgress: 'quoteId',
  purchaseOrder: 'quoteId',
}

export default {
  components: {
    BButton,
  },

  computed: {
    ...mapGetters('auth', ['currentUser']),
    ...mapGetters('quoteNotes', ['summaryFor']),
    ...mapGetters('quotes', ['quote']),

    quoteId() {
      const param = QUOTE_PARAM_BY_ROUTE[this.$route.name]
      return param ? this.$route.params[param] : null
    },

    visible() {
      return this.currentUser?.role_name === 'admin' && Boolean(this.quoteId)
    },

    count() {
      return this.summaryFor(this.quoteId)?.count || 0
    },

    ariaLabel() {
      if (!this.count) return 'Abrir bitácora de la cotización, sin notas'
      return `Abrir bitácora de la cotización, ${this.count} ${this.count === 1 ? 'nota' : 'notas'}`
    },
  },

  watch: {
    visible: {
      immediate: true,
      handler(value) {
        this.$emit('visibility-change', value)
      },
    },
    quoteId: {
      immediate: true,
      handler(quoteId) {
        if (this.visible) this.queueQuoteNotesSummary(quoteId)
      },
    },
  },

  methods: {
    ...mapActions('quoteNotes', ['queueQuoteNotesSummary']),
    ...mapMutations('quoteNotes', { openPanel: 'OPEN_PANEL' }),

    open() {
      const folio = this.quote?.id === this.quoteId ? this.quote.folio : null
      this.openPanel({ quoteId: this.quoteId, folio })
    },
  },
}
</script>

<style lang="scss" scoped>
.quote-log-launcher {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  height: 2.6rem;
  margin-right: 1rem;
  padding: 0 0.85rem 0 0.45rem;
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-weight: 600;
  text-decoration: none;
  box-shadow: none;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.4);
    color: #fff;
  }

  &:focus {
    color: #fff;
    box-shadow: none;
  }

  &:focus-visible {
    outline: 2px solid #fff;
    outline-offset: 2px;
  }
}

.quote-log-launcher__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.9rem;
  height: 1.9rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.16);
}

.quote-log-launcher__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.4rem;
  height: 1.4rem;
  padding: 0 0.35rem;
  border-radius: 999px;
  background: #fff;
  color: #340668;
  font-size: 0.75rem;
  font-weight: 700;
}

@media (prefers-reduced-motion: reduce) {
  .quote-log-launcher {
    transition: none;
  }
}

@media (max-width: 575.98px) {
  .quote-log-launcher {
    margin-right: 0.5rem;
  }
}
</style>
